/*
 * Project: OKIT.VCM
 * 
 * Copyright 2023 by OKIT GmbH
 * All rights reserved.
 * 
 * Diese Software ist urheberrechtlich geschützt.
 */
import axios from "axios";
import apiList from "../utils/apiClient.js";

/**
 * This component implements the api's call
 * 
 * @author hatem sfar
 *
 */
// Single-flight + short TTL to avoid duplicate `/api/session/session` calls
// when multiple components mount at the same time (App + Map + others).
let inFlightPromise = null;
let lastResult = { value: null, atMs: 0 };
// Keep a longer TTL for non-null results (avoid noisy polling once ready),
// but expire null results quickly so the Map bootstrap retry loop can
// observe the session becoming available shortly after CAS login.
const ttlMsNonNull = 15000;
const ttlMsNull = 2000;

const getSessionClientPrefixApi = async () => {
  const now = Date.now();

  // Serve from short TTL cache.
  const ttlMs = lastResult.value ? ttlMsNonNull : ttlMsNull;
  if (now - lastResult.atMs < ttlMs) {
    return lastResult.value;
  }

  // Reuse an in-flight request.
  if (inFlightPromise) {
    return inFlightPromise;
  }

  inFlightPromise = (async () => {
    const { data } = await axios.get(apiList.SessionClientPrefix);
    lastResult = { value: data, atMs: Date.now() };
    return data;
  })();

  try {
    return await inFlightPromise;
  } finally {
    inFlightPromise = null;
  }
};

export {
    getSessionClientPrefixApi
}
